import { render, staticRenderFns } from "./QuestionsStatus.vue?vue&type=template&id=11047e02&"
import script from "./QuestionsStatus.vue?vue&type=script&lang=js&"
export * from "./QuestionsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports